var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e59124",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64.325 64.324",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.865,34.72c-1.906,0-3.754-0.614-4.957-1.231L0,37.184c1.114,0.616,3.344,1.202,5.602,1.202 c5.426,0,7.977-2.815,7.977-6.129c0-2.786-1.643-4.604-5.132-5.895c-2.552-0.969-3.666-1.525-3.666-2.786 c0-1.027,0.938-1.907,2.874-1.907s3.344,0.558,4.135,0.939l0.998-3.607c-1.174-0.528-2.816-0.997-5.045-0.997 c-4.663,0-7.479,2.58-7.479,5.953c0,2.874,2.141,4.692,5.426,5.836c2.375,0.851,3.314,1.555,3.314,2.785 C9.004,33.869,7.918,34.72,5.865,34.72z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.211,34.427 21.088,34.427 21.088,29.735 28.36,29.735 28.36,26.098 21.088,26.098 21.088,21.992 28.801,21.992 28.801,18.326 16.6,18.326 16.6,38.093 29.211,38.093 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.326,39.593c2.775,0,5.318-0.999,7.298-2.653l3.937,3.674c-0.006,0.41,0.143,0.816,0.465,1.117l5.777,5.394 c0.289,0.27,0.655,0.403,1.022,0.403c0.401,0,0.802-0.16,1.097-0.478c0.565-0.604,0.532-1.556-0.072-2.12l-5.777-5.393 c-0.322-0.301-0.74-0.42-1.146-0.387l-3.885-3.625c1.671-1.983,2.684-4.541,2.684-7.332c0-6.285-5.112-11.397-11.397-11.397 S32.929,21.91,32.929,28.194C32.928,34.48,38.041,39.593,44.326,39.593z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.2d8cd40063e3d283f1b4dcc3d418bc84.svg";
export { ForwardRef as ReactComponent };